import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Home/Home";
import HangarInfo from "./HangarInfo/HangarInfo";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thehangarglobal" element={<HangarInfo />} />
      </Routes>
    </Router>
  );
};

export default App;
